// Dynamic Experiments
export const REGISTRATION_ENTRYPOINTS_EXPERIMENT_ID =
  'card_6527_cardfinder_registration_save_matches';
export const TRAVEL_NEWSLETTER_EXPERIMENT_ID = 'card_6556_cardfinder_travel_newsletter_widget';
export const CARDFINDER_THINKING_INTERSTITIAL_ID = 'card_6668_cardfinder_thinking_interstitial';
